<router-outlet></router-outlet>
<ngx-spinner type="ball-scale-multiple"></ngx-spinner>
<app-clarity-consent-modal></app-clarity-consent-modal>
<alert></alert>
<button hidden routerLink="/log-out" id="logOut">Log out</button>
<button hidden routerLink="/mantenimiento-error" id="mantenimiento-error">Mantenimiento</button>
<!-- Modal de inactividad -->
<div class="modal fade text-center" id="inactivoModal" tabindex="-1" aria-labelledby="inactivoModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header justify-content-md-center">
        <h5 class="modal-title" id="inactivoModalLabel">¡NO SE DETECTA ACTIVIDAD EN LA PÁGINA!</h5>
      </div>
      <div class="modal-body-monto justify-content-md-center">
        <div class="row">
          <div class="col-12 col-sm-12 me-3 ms-3">
            <p>{{mensajeModal}}</p>
          </div>
        </div>
      </div>
      <div class="modal-footer justify-content-md-center">
        @if (mensajeModal == 'Te hemos desconectado por inactividad.') {
        <button type="button" class="btn btn-primary" data-bs-dismiss="modal">Aceptar</button>
        }
        @if (mensajeModal != 'Te hemos desconectado por inactividad.') {
        <button type="button" class="btn btn-primary" (click)="stay()">Mantener Sesión</button>
        }
        @if (mensajeModal != 'Te hemos desconectado por inactividad.') {
        <button type="button" class="btn btn-primary" (click)="logOut()">Cerrar Sesión</button>
        }
      </div>
    </div>
  </div>
</div>